import globalConfig from "../config/global-variables";
import loginModel from "../models/login.model";
import getRequestURL from '../utils/getRequestURL';

/**
 * Calculate the loading time of all APIs on each menu.
 */
const apiResponseTimeService = {
  menuXhrMap: {
    menu: "",
    requestStartTime: 0,
    xhrMap: new Map()
  },
  setMenuXhrMap: function (menuPath = "") {
    this.menuXhrMap = Object.assign({
      menu: menuPath,
      requestStartTime: performance.now(),
      xhrMap: new Map()
    })
  },
  addXhr: function (newGuid, xhr) {
    if (this.menuXhrMap?.menu === m.route.get()) {
      this.menuXhrMap.xhrMap.set(newGuid, xhr);
    }
  },
  process: function (guid) {
    this.deleteXhrMap(guid);
    if (m.route.get() === this.menuXhrMap.menu && this.menuXhrMap.xhrMap.size === 0 && loginModel.isAuthenticated()) {
      this.sendMenuAccessTime(performance.now() - this.menuXhrMap.requestStartTime);
    }
  },
  sendMenuAccessTime: function (time) {
    const requestParam = {
        url: getRequestURL('/api/executesp/responsetime/log'),
        method: 'POST',
        withCredentials: true,
        headers: {
          'Accept-Country':  loginModel.credentials.country,
          'Accept-Language': loginModel.credentials.language
        },
        body: {
            responseTime: parseInt(time),
            host: globalConfig.API_URL,
            pathName: this.menuXhrMap.menu,
            pageUrl: globalConfig.API_URL + this.menuXhrMap.menu,
            protocol: location.protocol
        }
    };

    return m.request(requestParam)
        .then((result) => {
          this.setMenuXhrMap();
        })
        .catch((error) => {
          throw error;
        });
    
  },
  deleteXhrMap: function (guid) {
    this.menuXhrMap.xhrMap.delete(guid);
  }
}


export default apiResponseTimeService;